<template>
  <div class='indexbox'>
    <!-- <wallet-head show_type="10" /> -->
    <nav-bar :title="$t('我的订单')" left-arrow />
    <!-- <nav-bar :title="$t('我的矿机')" left-arrow /> -->
    <van-tabs v-model="active" sticky offset-top="12.3vw" background="#0F0F0F" color="#E6B17F"
      title-inactive-color="#808080" title-active-color="#E6B17F" @click="change">
      <van-tab :title="$t(val.title)" v-for="val in toplist" :key="val.id">
        <van-list v-model="loading" :finished="finished" :finished-text="$t('没有更多了')" @load="onLoad" :offset="0">
          <div class="item" v-for="item in list" :key="item.id">
            <img @click="lookImg(item.product_cover)" v-lazy="item.product_cover" alt="">
            <div class="r">
              <p class="n">{{ item.product_name }}</p>
              <p class="p">
                <span>{{ $t('已产出') }}：</span>
                <span>{{ item.has_release_equity }}T</span>
              </p>
              <p class="p">
                <span>{{ $t('待产出') }}：</span>
                <span>{{ ((item.equity * 1) - (item.has_release_equity * 1)).toFixed(4) }}T</span>
              </p>
              <p>
                <span>{{ $t('收益率') }}：</span>
                <span>{{ item.rate }}%</span>
              </p>
              <!-- <p>
                <span>{{ $t('周期') }}：</span>
                <span>{{ item.cycle }}</span>
              </p> -->
              <p v-if="item.express">
                <span>{{ $t('快递公司') }}：</span>
                <span>{{ item.express }}</span>
              </p>
              <p>
                <span v-if="item.express_no">{{ $t('快递单号') }}：</span>
                <span>{{ item.express_no }}</span>
              </p>

              <p>
                <span>{{ $t('运行天数') }}：</span>
                <span>{{ item.num }}</span>
              </p>

              <template v-if="active == 0">
                <p>
                  <span>{{ $t('购买日期') }}：</span>
                  <span>{{ item.created_at }}</span>
                </p>
                <van-button v-if="item.status == 3" size="mini" round
                  color=" linear-gradient( 90deg, #EBC699 0%, #CD823A 100%)">
                  {{ $t('启动') }}</van-button>
                <p v-if="item.status == 1" style="color:#CD823A">{{ $t('运行中') }}...</p>
              </template>

              <template v-if="active == 1">
                <p>
                  <span>{{ $t('到期日期') }}：</span>
                  <span>{{ item.end_time }}</span>
                </p>
                <p style="color:#FF4040;">{{ $t('已过期') }}</p>
              </template>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 0,
      toplist: [{ title: '我的收益', id: 0 }, { title: '过期收益', id: 1 }],
      list: [],
      page: 1,
      loading: false,
      finished: false,
    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {
    change() {
      this.page = 1
      this.list = []
      this.finished = false
      this.onLoad()
    },
    onLoad() {
      let page = this.page++
      this.$get({
        url: "/api/v1/user/machine",
        data: {
          page,
          status: Number(this.active) + 1
        },
        success: (res) => {
          if (!res.data || res.data.data.length == 0) {
            this.finished = true
          } else {
            var list = res.data.data
            if (page == 1) {
              this.list = list
            } else {
              for (var i in list) {
                this.list.push(list[i])
              }
            }
          }
          this.loading = false
        },
        tip: () => {
          this.finished = true
        },
      })
    },
  },
}
</script>
<style lang='less' scoped>
/deep/.van-tabs__content {
  width: 100%;
  padding: 15px;
}

.item {
  width: 100%;
  border-radius: 6px;
  padding: 10px;
  margin-bottom: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background-color: #1A1C1D;

  img {
    width: 100px;
    height: 100px;
    border-radius: 5px;
  }

  .r {
    width: 66%;

    >p {
      width: 100%;
      line-height: 1.6;
      color: #C7C7CC;
      font-size: 12px;
    }

    .n {
      color: #FFFFFF;
      font-size: 17px;
      font-weight: 550;
    }

    .p {
      color: #E6B17F;
      padding: 2px 0 0;
    }

    /deep/.van-button {
      width: 40%;
      padding: 12px 10px;
      margin-top: 10px;

      .van-button__text {
        color: #fff;
        font-size: 14px;
      }
    }
  }
}

.wa {
  background: url('../../../assets/img/1.gif') no-repeat;
  background-size: 96px 120px;
  background-position: bottom right;
}
</style>